import React from 'react'
import {store} from '../../stores/store'
import { observer } from 'mobx-react'
import PopupStore, { POPUPS_IDS } from '../../stores/PopupStore'

function Marker({data, dimensions}) {
  let {id, x, y} = data

  let {scale, offsetLeft, offsetTop} = dimensions

  function open() {
    PopupStore.open(POPUPS_IDS.AEPS, data)
  }

  const s = {
    left: ((x / scale) + offsetLeft)  + "px",
    top: ((y / scale) + offsetTop)  + "px"
  }

  let c = "marker"



  return (
      <div className={c} style={s} onClick={open} >
        <div className={"marker-icon " + id} />
        <div className="marker-title">{store.t(id)}</div>
      </div>

  )
}

export default observer(Marker)
